import { faBan } from '@fortawesome/pro-solid-svg-icons';
import type { FC } from 'react';
import { Stack } from 'src/components/layout/stack';
import { Modal } from 'src/components/overlay/modal';
import { useCountdown } from 'src/hooks/use-countdown';

type Props = {
  close: () => void;
  onConfirm: () => void;
  pending: boolean;
};

export const WithdrawOrgAssignmentModal: FC<Props> = ({
  close,
  onConfirm,
  pending,
}) => {
  const seconds = useCountdown();

  return (
    <Modal
      data-testid="withdraw-assignment-modal"
      title="Withdraw Assignment"
      icon={faBan}
      onDismiss={close}
      footer={{
        confirmButton: {
          label: seconds
            ? `Wait ${seconds}s to proceed...`
            : pending
              ? 'Pending...'
              : 'Withdraw Assignment',
          onClick: onConfirm,
          disabled: pending || seconds !== 0,
          dataTestId: seconds === 0 ? 'withdraw-assignment-submit' : undefined,
        },
      }}
    >
      <Stack gap={1.5}>
        <p data-testid="withdraw-assignment-content">
          The withdrawal of an organisation assignment will also withdraw all
          user assignments.
        </p>
      </Stack>
    </Modal>
  );
};
